// extracted by mini-css-extract-plugin
module.exports = {"button":"style_button__3_HAl","gradient":"style_gradient__2x16C"};